var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.034,
    height: 26.137,
    viewBox: "0 0 26.034 26.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M5.151,30.1a1.761,1.761,0,0,1,0-2.484L27.574,5.2A1.761,1.761,0,1,1,30.057,7.68L7.635,30.1a1.761,1.761,0,0,1-2.484,0Z",
    transform: "translate(-4.639 -4.58)",
    fill: "#63879a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M5.151,5.151a1.761,1.761,0,0,1,2.484,0L30.057,27.574a1.761,1.761,0,1,1-2.484,2.484L5.151,7.635A1.761,1.761,0,0,1,5.151,5.151Z",
    transform: "translate(-4.639 -4.536)",
    fill: "#63879a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close_btn.0890c2ba3a879eb7e594d92d907321c9.svg";
export { ForwardRef as ReactComponent };